export class CommonContainerConst {
    public static readonly shellApi_appConfig: string = 'shellApi_appConfig';
    public static readonly messagingClient: string = 'messagingClient';
    public static readonly fetchService: string = 'fetchService';
    public static readonly router: string = 'router';
}
